<template>
	<div style="min-width: 500px">
		<div v-if="!isLoading">
			<div class="m-4" v-if="this.vehicle.kilometrageChanges && this.vehicle.kilometrageChanges.length <= 0">
				<b>{{ $t('no_processes') }}</b>
			</div>
			<div
				class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded"
				v-if="this.vehicle.kilometrageChanges && this.vehicle.kilometrageChanges.length > 0"
			>
				<table class="min-w-full">
					<thead class="w-full" style="height: fit-content;">
						<tr class="w-full">
							<HeaderColumn style="width: fit-content">{{ $t('mileage') }}</HeaderColumn>
							<HeaderColumn>{{ $t('change_date') }}</HeaderColumn>
						</tr>
					</thead>
					<tbody class="bg-white">
						<tr v-for="(process, index) in vehicle.kilometrageChanges" :key="process.id" class="tr odd:bg-gray-200 cursor-pointer">
							<td class="px-6 py-4 w-3/12" :class="index !== vehicle.kilometrageChanges.length - 1 ? 'border-b border-gray-200' : ''">
								{{ process.kilometrage }}
							</td>
							<td class=" py-4 w-2/12" :class="index !== vehicle.kilometrageChanges.length - 1 ? 'border-b border-gray-200' : ''">
								{{ getGermanDate(process.created) }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<LoadingSpinner v-else />
	</div>
</template>
<script>
import { VehiclesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import HeaderColumn from '@/components/columns/HeaderColumn.vue';
import { getGermanDate } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'KilometrageChangeCard',
	components: { HeaderColumn, LoadingSpinner },
	mixins: [Authentication],
	props: {
		concatString: {},
		damageCase: {},
		isProcessFinished: {},
		openChargeRatesModal: {},
	},
	data() {
		return {
			vehicle: null,
			isLoading: true,
		};
	},
	mounted() {
		if (!this.isUserAllowedInLevel5or6) {
			this.$emit('authNotAllowed');
		} else {
			this.isLoading = true;
			this.getVehicleData();
		}
	},
	methods: {
		getGermanDate,
		getVehicleData() {
			VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.vehiclesIdGet(parseInt(this.$route.params.vehicleId))
				.then(response => {
					this.vehicle = response.data;
					this.isLoading = false;
				});
		},
	},
};
</script>
